import React, { FC, useCallback, useMemo, useRef, useState } from 'react'
import styled, { css } from 'styled-components'

const Accordion: FC<Props> = ({ renderButton, renderContent, withTransition = true }) => {
  const [isActive, setIsActive] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const onToggle = useCallback(() => {
    setIsActive(!isActive)
  }, [isActive])

  const height = useMemo(() => (isActive ? Number(contentRef.current?.offsetHeight) : 0), [isActive])

  return (
    <Wrap>
      {renderButton(onToggle, isActive)}
      <Container $height={height} $withTransition={withTransition}>
        <Content ref={contentRef}>{renderContent()}</Content>
      </Container>
    </Wrap>
  )
}

export default Accordion

interface Props {
  renderButton: (onToggle: () => void, isActive: boolean) => JSX.Element
  renderContent: () => JSX.Element
  withTransition?: boolean
}

const Wrap = styled.div`
  -webkit-tap-highlight-color: transparent;
`

const Content = styled.div``

const Container = styled.div<{ $height: number; $withTransition: boolean }>`
  width: 100%;
  overflow: hidden;
  height: ${({ $height }) => $height}px;
  ${({ $withTransition }) =>
    $withTransition &&
    css`
      transition: all 0.3s;
    `}
`
